"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utcToZonedTime_1 = __importDefault(require("date-fns-tz/utcToZonedTime"));
const format_1 = __importDefault(require("date-fns/format"));
const format_2 = __importDefault(require("date-fns-tz/format"));
const ru_1 = __importDefault(require("date-fns/locale/ru"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const dateFnsLocales = {
    en: en_US_1.default,
    ru: ru_1.default,
};
function formatDate(value, format, lng) {
    if (!format) {
        return value;
    }
    if (format.includes('|')) {
        const [tz, dateFormat] = format.split('|').map(s => s.trim());
        const zonedDate = (0, utcToZonedTime_1.default)(value, tz);
        return (0, format_2.default)(zonedDate, dateFormat, {
            locale: dateFnsLocales[lng],
            timeZone: tz,
        });
    }
    return (0, format_1.default)(value, format, {
        locale: dateFnsLocales[lng],
    });
}
exports.default = formatDate;
